module.exports = {
      id: "ic-50-index-v-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-50-index-v-usage",
      toString: function () {
        return this.url;
      }
    }